/**
 * The "something long is running" overlay: dims the board, swallows clicks,
 * and — the part that was missing — actually shows a spinner.
 *
 * Two things kept it invisible. It used Metronic's `indicator-progress`, which
 * `_indicator.scss` sets to `display: none` unless an ancestor carries
 * `data-fds-indicator="on"` (nothing here does), so the box rendered at zero
 * size. And the overlay covers the whole scrolling board, which is far taller
 * than the window, so even shown it centred itself in the *document* rather
 * than the viewport. The card below sticks to the visible area instead — see
 * the `rs__table_loading` rules in ../../styles/styles.ts.
 *
 * The result is that a long action (auto-fill runs ~2s) reads as working
 * rather than frozen.
 */
interface LoadingOverlayProps {
  /** What is being waited on. Kept short — it sits under the spinner. */
  message?: string
}

const LoadingOverlay = ({message = 'Please wait...'}: LoadingOverlayProps) => (
  <div className='rs__table_loading' data-testid='rs-loading-overlay'>
    <span>
      <span className='rs__loading_card'>
        {/* Sized here rather than with `spinner-border-lg`, which the old
            markup used and Bootstrap does not define — only `-sm` exists. */}
        <span
          className='spinner-border text-primary'
          style={{width: '2.5rem', height: '2.5rem'}}
          role='status'
          aria-hidden='true'
        />
        <span className='fw-semibold text-gray-800' role='status' aria-live='polite'>
          {message}
        </span>
      </span>
    </span>
  </div>
)

export default LoadingOverlay
